import React from 'react';

import { COLOR } from '../../Theme';
import ScoreRangeTableHorizontal from './ScoreRangeTable.view';
import ScoreRangeTableVertical from './ScoreRangeTableVertical.view';

const getTablePrimaryColor = variant => {
  switch (variant) {
    case 'blue':
      return '#4a95d8';
    case 'red':
    default:
      return COLOR.primary;
  }
};

const ScoreRangeTable = ({ variant, themeColor, ...restProps }) => {
  const color = getTablePrimaryColor(themeColor);
  switch (variant) {
    case 'vertical':
      return <ScoreRangeTableVertical themeColor={color} {...restProps} />;
    case 'horizontal':
    default:
      return <ScoreRangeTableHorizontal themeColor={color} {...restProps} />;
  }
};

export default ScoreRangeTable;
